var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('v-container',{staticClass:"fill-height",attrs:{"fluid":""}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-btn',{staticClass:"mr-4",attrs:{"type":"submit","color":"success"},on:{"click":function($event){$event.preventDefault();return _vm.gotoLogin.apply(null, arguments)}}},[_vm._v("重新登入")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }